import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

class Viewport extends Component {
  constructor (props) {
    super(props)

    this.loading = false
    this.init(props)
  }

  resetLayers () {
    this.layers = []
  }

  setLoading (state = true) {
    this.loading = state
  }

  preloadLayers (assets, callback) {
    let counter = 0
    this.setLoading()
    this.resetLayers()

    assets.forEach(a => {
      const img = new window.Image()

      img.onload = () => {
        counter++
        if (counter === assets.length) {
          this.setLoading(false)
          callback()
        }
      }
      img.onerror = () => this.setLoading(false)
      img.src = a

      this.layers.push(img)
    })
  }

  componentWillReceiveProps (props) {
    this.init(props)
  }

  init (props) {
    const layers = props.children
      .filter(layer => layer !== null)
      .map(layer => layer.props.asset)

    this.preloadLayers(layers, this.drawCanvas.bind(this))
  }

  drawCanvas () {
    const viewport = ReactDOM.findDOMNode(this.refs.visualizeViewport)
    const ctx = viewport.getContext('2d')

    // Delete everything before drawing again
    ctx.clearRect(0, 0, this.props.width, this.props.height)

    this.layers.forEach(layer => {
      ctx.drawImage(layer, 0, 0, this.props.width, this.props.height)
    })
  }

  static renderCanvas () {
    return document.getElementById('visualizeViewport').toDataURL()
  }

  render () {
    // let css = {}
    // let classes = ['visualize-viewport']
    //
    // if (typeof this.props.dimensions === 'object') {
    //   const dimensions = Object.assign({
    //     width: 720,
    //     height: 480,
    //     unit: 'px'
    //   }, this.props.dimensions)
    //   css.width = dimensions.width + dimensions.unit
    //   css.height = dimensions.height + dimensions.unit
    // } else {
    //   classes.push('visualize-viewport-full-scale')
    // }
    //
    // // Adding aspect ratio to the viewport
    // let aspectRatio = 100 // default 100% is a square
    // if (typeof this.props.aspectRatio !== 'undefined') {
    //   switch (typeof this.props.aspectRatio) {
    //     case 'number' :
    //       aspectRatio = this.props.aspectRatio
    //       break
    //     case 'string' :
    //       const ratio = this.props.aspectRatio.match(/([0-9]+)[:/-]([0-9]+)/)
    //       aspectRatio = ratio[2] / ratio[1] * 100
    //       break
    //     default :
    //       break
    //   }
    //   // css.width = ((aspectRatio >= 100) ? aspectRatio : 100) + 'vw'
    //   // css.height = ((aspectRatio < 100) ? aspectRatio : 100) + 'vw'
    //   css.paddingTop = aspectRatio + '%'
    // }

    return (
      // <div className={classes.join(' ')} style={css}>
      //   {this.props.children}
      // </div>
      <div className='visualize-viewport'>
        <canvas
          id='visualizeViewport'
          ref='visualizeViewport'
          className='visualize-viewport'
          width={this.props.width}
          height={this.props.height}
        />
        {
          this.props.children
            .filter(child => child !== null)
            .filter(child => child.type === 'img')
        }
      </div>
    )
  }
}

Viewport.propTypes = {
  children: PropTypes.node
}

export default Viewport



// WEBPACK FOOTER //
// ./src/lib/react-visualize/Core/Viewport.js